export class DialogAction {
	readonly id: string;
	readonly labelKey: string;
	readonly primary: boolean;
	readonly cssClass: string = "";

	constructor (id: string, labelKey: string, primary: boolean, cssClass: string = "") {
		this.id = id;
		this.labelKey = labelKey;
		this.primary = primary;
		this.cssClass = cssClass;
	}
}
